import MailMagazineService from '../../ports/MailMagazineService';

export type getAccessTokenUseCase = (userId: string) => Promise<string>;

export const buildGetAccessToken = (dependencies: {
  mailMagazineService: MailMagazineService;
}): getAccessTokenUseCase => {
  const { mailMagazineService } = dependencies;

  const getAccessToken: getAccessTokenUseCase = async () => {
    try {
      const accessToken = await mailMagazineService.getAccessToken();

      return accessToken;
    } catch (error) {
      throw error;
    }
  };

  return getAccessToken;
};
